import React from "react";
import { Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import IndicatorReportsConfigForm from "~/components/Forms/IndicatorReportsConfigForm";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";

const IndicatorReportConfigModal = () => {
  const { t } = useTranslation();
  const { openModal } = useGetLocationData();
  // Открытие/закрытие модалки — через replace, чтобы не плодить историю браузера
  const setDataReplace = useSetLocationData(true);

  const configModalIsOpen = openModal === "ReportConfigModal";
  const handleCloseModal = () =>
    setDataReplace("openModal", "", "currentId", "");

  return (
    <Modal
      open={configModalIsOpen}
      title={t("reports.filterTitle")}
      onCancel={handleCloseModal}
      closable
      centered
      destroyOnHidden
      footer={null}
    >
      <IndicatorReportsConfigForm />
    </Modal>
  );
};

export default IndicatorReportConfigModal;
